import React, { useState } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AddRowTable from '../../Components/Table/AddRowTable';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';


import { 
    Layout,
    Col, 
    Row,
    Button,
    // Modal,
    Checkbox,
    Upload,
    Form,
    Select,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    AutoComplete,
    Modal,
    Space,
} from 'antd'
import { ExclamationCircleFilled, InboxOutlined } from '@ant-design/icons';
// import { isAnyRequiredFieldEmpty } from '../../Utils/Common';
import { useNavigate } from 'react-router-dom';
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatDate } from '../../Utils/Common';

// const { Search } = Input;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const AddTenants = () => {
    const [addTenantForm] = Form.useForm();
    const navigate = useNavigate()
    const currentDate = new Date().toISOString().split('T')[0];
    const [startContractData, setStartContractDate] = useState({
        start_date: currentDate
    })
    const [isDisabled, setIsDisabled] = useState(true);
    const [isCusa, setIsCusa] = useState(false);
    const [isAlfresco, setIsAlfresco] = useState(false);
    const [propertyId, setPropertyId] = useState('')
    const [leaseTerm, setLeaseTerm] = useState('')
    const [leaseType, setLeaseType] = useState('year')
    const [authorizedSignatories, setAuthorizedSignatories] = useState([{}]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [authorizedRepresentative, setAuthorizedRepresentative] = useState([{}]);
    const [propertyData, setPropertyData] = useState([])
    const [rentalData, setRentalData] = useState([])
    const [tenantData, setTenantData] = useState([])
    const [options, setOptions] = useState([])
    const [renterId, setRenterId] = useState('')
    const [contractDate, setContractDate] = useState([])
    const { callPost, data, loading } = usePostRequest(()=>{
        addTenantForm.resetFields();
    });
    const values = Form.useWatch([], addTenantForm);
    React.useEffect(() => {
        addTenantForm.validateFields({
        validateOnly: true,
        }).then(() => {
        setIsDisabled(false);
        },
        () => {
        setIsDisabled(true);
        },
        );
    }, [values, addTenantForm]);

    React.useEffect(() => {
        if (data) {
            navigate('/tenant/rate/' + data.tenant_id);
        }
    }, [data, navigate]);

    React.useEffect(() => {
        fetchRentalData();
        fetchPropertyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    React.useEffect(() => {
        fetchTenantData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleProperty = (e) => {
        setPropertyId(e)
    }

    const handleRentalUnit = (rental_id) => {
        const rent = rentalData.filter((item) => item.id === rental_id);
        if(rent[0]?.pricing_type === "unit"){
            addTenantForm.setFieldsValue({
                space_rental_rate: rent[0].unit_price,
                property: rent[0].property_id
            });
        } else {
            addTenantForm.setFieldsValue({
                space_rental_rate: '',
                property: rent[0].property_id
            });
        }
        setIsAlfresco( rent[0].cusa_area !== "0.00" ? true : false )
        setIsCusa( rent[0].alfresco_area !== "0.00" ? true : false )
    }

    async function fetchPropertyData() {

        const response = await UseGetRequest("properties/get_for_contract", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    
    }

    async function fetchRentalData() {

        const response = await UseGetRequest("rental_units/get", {property_id: propertyId, status: 'vacant'});
        if (response?.data) {
          setRentalData(response?.data?.data);
        } else {
          setRentalData([])
        }
    
    }

    async function fetchTenantData() {

        const response = await UseGetRequest("tenants/get_active_renter",);
        if (response?.data) {
          setTenantData(response?.data?.data);
        } else {
          setTenantData([])
        }
    
    }

    const handleAddTenant = () => {
        
        addTenantForm.validateFields().then(values => {
            const resetData = {
                alfresco_rental_rate: values.alfresco_rental_rate || '',
                require_or: values.require_or === true ? '1' : '0',
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD") || '',
                cusa_rental_rate: values.cusa_rental_rate || '',
                lease_type: values.lease_type || '',
                lease_term: values.lease_term || '',
                property: values.property || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
            };

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            if (renterId) {
                resetData.renter_id = renterId;
            }            

            resetData.signatory_name = authorizedSignatories.map((item)=>item.signatory_name || "")
            resetData.signatory_position = authorizedSignatories.map((item)=>item.signatory_position || "")

            resetData.representative_name = authorizedRepresentative.map((item)=>item.representative_name || "")
            resetData.representative_position = authorizedRepresentative.map((item)=>item.representative_position || "")
            resetData.representative_email = authorizedRepresentative.map((item)=>item.representative_email || "")
            resetData.representative_contact_no = authorizedRepresentative.map((item)=>item.representative_contact_no || "")

            // const file = values.attachments.map((file) => {
            //     return file.originFileObj;
            // });
            var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
                key,
                value,
            }));


            callPost(
                "tenants/create", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const normFile = (e) => {

        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
        
    };

    const validateContactNumber = (_, value) => {
        if (!value) {
          return Promise.resolve();
        }
    
        const isNumber = /^\d+$/.test(value);
        if (!isNumber) {
          return Promise.reject('Invalid Contact Number');
        }
        return Promise.resolve();
    };

    const onLeaseType = (value) => {
        if (value) {
            setLeaseType(value)
            if(value === "month"){
                addTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').add(leaseTerm, value).subtract(1, 'day')
                    ]
                });
                setContractDate([
                    dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                    dayjs(startContractData.start_date, 'YYYY/MM/DD').add(leaseTerm, value).subtract(1, 'day')
                ])
            } else {
                addTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').add(leaseTerm, value).subtract(1, 'day')
                    ]
                });
                setContractDate([
                    dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                    dayjs(startContractData.start_date, 'YYYY/MM/DD').add(leaseTerm, value).subtract(1, 'day')
                ])
            }
        }
    }

    const onLeaseChange = (value) => {
        if (value) {
            setLeaseTerm(value)
            if(leaseType === "month"){
                addTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                    ]
                });
                setContractDate([
                    dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                    dayjs(startContractData.start_date, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                ])
            } else {
                addTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                    ]
                });
                setContractDate([
                    dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                    dayjs(startContractData.start_date, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                ])
            }
        }
    }

    const handleRangeChange = (dates) => {
        if (dates && dates.length > 0) {
            addTenantForm.setFieldsValue({
                contract_date: [
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').add(leaseTerm, leaseType).subtract(1, 'day')
                ]
            });
            setStartContractDate(() => ({
                start_date: dates[0]
            }))
            setContractDate([
                dayjs(dates[0], 'YYYY/MM/DD'),
                dayjs(dates[0], 'YYYY/MM/DD').add(leaseTerm, leaseType).subtract(1, 'day')
            ])
        }
    };
    const showSaveConfirm = () => {
        confirm({
          title: 'Please review Lease Term and Contract Date',
          icon: <ExclamationCircleFilled style={{ color: 'yellow' }}/>,
          content: (
            <div>
              <div>Lease Term: {leaseTerm} {leaseType}</div>
              <div>Contract Date: {formatDate(contractDate[0].format("YYYY-MM-DD"))} - {formatDate(contractDate[1].format("YYYY-MM-DD"))}</div>
            </div>
          ),
          okText: 'Yes',
          cancelText: 'No',
          className: 'custom-modal',
          confirmLoading: loading,
          onOk() {
            handleAddTenant()
          },
        });
    };

    const fetchOptions = (value) => {
        const data = tenantData
        return data
            .filter(item => item.trade_name.toLowerCase().includes(value.toLowerCase()))
            .map(item => ({ value: item.trade_name }));
    };

    const handleonSearch = (value) => {
        const fetchedOptions = fetchOptions(value);
        setOptions(fetchedOptions);
    };
    const handleOnSelect = (value) => {
        const item = tenantData.find(option => option.trade_name === value);
        setRenterId(item.renter_id);
    };
    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        ADD RENTER
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-3'>
                        <Form form={addTenantForm} initialValues={{ lease_type: leaseType }} layout="vertical" scrollToFirstError={true}>
                            <Divider className='divider-text'>Renter Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Name"
                                        name="trade_name"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <AutoComplete
                                        options={options}
                                        onSearch={handleonSearch}
                                        onSelect={handleOnSelect}
                                        placeholder="Type to search"
                                        >
                                        <Input />
                                        </AutoComplete>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Name"
                                        name="business_name"
                                        // rules={[{ required: true, message: 'Please enter your confirm Business Name!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Address"
                                        name="business_address"
                                        rules={[{ required: true, message: 'Please enter your confirm Business Address!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                        // rules={[{ required: true, message: 'Please enter your Tin!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Renter Email"
                                        name="renter_email"
                                        rules={[
                                            { required: true, message: 'Please enter your email address!' },
                                            { type: 'email', message: 'Please enter a valid email address!' }
                                        ]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Contact Number"
                                        name="contact_no"
                                        rules={
                                            [
                                                { 
                                                    required: true, message: 'Please enter your Contact Number!' 
                                                },
                                                {
                                                    validator: validateContactNumber
                                                },
                                            ]
                                        }
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                    <Item
                                        label="Nature of Renter"
                                        name="business_nature"
                                        // rules={[{ required: true, message: 'Please enter your confirm Contact Person!' }]}
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text mt-5'>Contract Detail</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Property/Building"
                                        name="property"
                                        rules={[{ required: true, message: 'Please select your Property/Building' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a property" 
                                            onChange={(e) => handleProperty(e)}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {propertyData?.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Unit Number"
                                        name="rental_unit_id"
                                        rules={[{ required: true, message: 'Please select your Unit Number' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Rental Unit" 
                                            onChange={(e) => handleRentalUnit(e)}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {rentalData?.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8} className='center pt-4'>
                                    <Item name="require_or" valuePropName="checked">
                                        <Checkbox>OR Required upon Payment</Checkbox>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Lease Type"
                                        name="lease_type"
                                        rules={[{ required: true, message: 'Please select your Lease Type' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Lease Type" 
                                            onChange={(e) => onLeaseType(e)}
                                            defaultValue={leaseType} 
                                        >
                                            {/* <Option key='day' value='daily'>Daily</Option> */}
                                            <Option key='month' value='month'>Monthly</Option>
                                            <Option key='year' value='year'>Yearly</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Lease Term"
                                        name="lease_term"
                                        rules={[{ required: true, message: 'Please enter your Lease Term!' }]}
                                    >
                                        <InputNumber 
                                            min={0}
                                            style={{width:'100%'}}
                                            onChange={(e) => onLeaseChange(e)}
                                        />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item 
                                        name="contract_date"  
                                        label="Contract Date"
                                        rules={[{ required: true, message: 'Please enter your Signed Contract Date!' }]}
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            disabled={leaseTerm ? [false, true] : true}
                                            onChange={handleRangeChange}
                                            allowClear={false}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Move In Date"
                                        name="start_date"
                                        // rules={[{ required: true, message: 'Please enter your Commencement of Lease!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Rental Rate"
                                        name="space_rental_rate"
                                        rules={[{ required: true, message: 'Please enter your Rental Rate!' }]}
                                    >
                                        <InputNumber style={{width:'100%'}} />
                                    </Item>
                                </Col>
                                {
                                    isCusa && (
                                        <Col span={4}>
                                            <Item
                                                label="Cusa Rental Rate"
                                                name="cusa_rental_rate"
                                            >
                                                <InputNumber style={{width:'100%'}} />
                                            </Item>
                                        </Col>
                                    )
                                }
                                {
                                    isAlfresco && (
                                        <Col span={4}>
                                            <Item
                                                label="Alfresco Rental Rate"
                                                name="alfresco_rental_rate"
                                            >
                                                <InputNumber style={{width:'100%'}} />
                                            </Item>
                                        </Col>
                                    )
                                }
                            </Row>
                            <Divider className='divider-text'>Authorizations</Divider>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Authorized Signatories
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'>
                                <Col span={24} className='p-2'>
                                    <AddRowTable
                                        tableHeaders={[
                                        "Name",
                                        "Position",
                                        ]}
                                        headerSelector={[
                                        "signatory_name",
                                        "signatory_position",
                                        ]}
                                        withAction={true}
                                        withRender={false}
                                        withAddRow={true}
                                        isDisabled={isDisabled}
                                        setDataSource={setAuthorizedSignatories}
                                        dataSource={authorizedSignatories}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Local Authorized Representatives
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'>
                                <Col span={24} className='p-2'>
                                
                                <AddRowTable
                                    tableHeaders={[
                                    "Name",
                                    "Position",
                                    "Email",
                                    "Mobile Number",
                                    ]}
                                    headerSelector={[
                                    "representative_name",
                                    "representative_position",
                                    "representative_email",
                                    "representative_contact_no",
                                    ]}
                                    withAction={true}
                                    withRender={false}
                                    withAddRow={true}
                                    isDisabled={isDisabled}
                                    setDataSource={setAuthorizedRepresentative}
                                    dataSource={authorizedRepresentative}
                                />
                            
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width'>
                                <Col span={24} className='p-2'>
                                    <Item
                                        label="Attachment"
                                        >
                                        <Item name="attachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                            <Upload.Dragger name="files" action="/upload.do">
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                            </Upload.Dragger>
                                        </Item>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate('/tenant')}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={showSaveConfirm}
                                        loading={loading}
                                        type='primary'
                                        className='button-color btn-header'
                                        disabled={isDisabled}
                                    >
                                        Save
                                    </Button>
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddTenants
